const COMISSAO = 0.25;
const PERCENTUAL_BRUTO = 1.0738;

const MULTIPLICADOS_DANOS_SUBTRACAO = [
  'transportes_meios_adequados',
  'ext_utilizacao_competicoes',
  'ext_ambito_territorial',
  'ext_demais_usuarios',
];

// 6 - Scooter, 7 - Patinete, 8 - Monociclo, 9 - Diciclo
const TAXAS_MODAIS = {
  6: {
    danos_acidentais_subtracao: (0.0521512385919165 / 0.8) * 1.0738,
    acessorios_equipamentos: (0.0521512385919165 / 0.8) * 1.0738,
    transportes_meios_adequados: 0.004,
    ext_utilizacao_competicoes: 0.25,
    ext_ambito_territorial: 0.1,
    ext_demais_usuarios: 0.15,
    resp_civil_corporais: (0.0113242689513876 / 0.8) * 1.0738,
    resp_civil_materiais: (0.00700316632520023 / 0.8) * 1.0738,
  },
  7: {
    danos_acidentais_subtracao: (0.0372508847085118 / 0.8) * 1.0738,
    acessorios_equipamentos: (0.0372508847085118 / 0.8) * 1.0738,
    transportes_meios_adequados: 0.004,
    ext_utilizacao_competicoes: 0.25,
    ext_ambito_territorial: 0.1,
    ext_demais_usuarios: 0.15,
    resp_civil_corporais: (0.0113242689513876 / 0.8) * 1.0738,
    resp_civil_materiais: (0.00700316632520023 / 0.8) * 1.0738,
  },
  8: {
    danos_acidentais_subtracao: (0.050363196125908 / 0.8) * 1.0738,
    acessorios_equipamentos: (0.050363196125908 / 0.8) * 1.0738,
    transportes_meios_adequados: 0.004,
    ext_utilizacao_competicoes: 0.25,
    ext_ambito_territorial: 0.1,
    ext_demais_usuarios: 0.15,
    resp_civil_corporais: (0.0113242689513876 / 0.8) * 1.0738,
    resp_civil_materiais: (0.00700316632520023 / 0.8) * 1.0738,
  },
  9: {
    danos_acidentais_subtracao: (0.0318867573104861 / 0.8) * 1.0738,
    acessorios_equipamentos: (0.0318867573104861 / 0.8) * 1.0738,
    transportes_meios_adequados: 0.004,
    ext_utilizacao_competicoes: 0.25,
    ext_ambito_territorial: 0.1,
    ext_demais_usuarios: 0.15,
    resp_civil_corporais: (0.0113242689513876 / 0.8) * 1.0738,
    resp_civil_materiais: (0.00700316632520023 / 0.8) * 1.0738,
  },
};

const MINIMO_MODAIS = {
  6: {minimo: 536.9},
  7: {minimo: 268.45},
  8: {minimo: 375.83},
  9: {minimo: 375.83},
};

// 1-Urbana, 2-Road/Speed, 3-Mountain Bike, 4-Triathlon, 5-Fixa
const TAXAS_BICI_SURA_BASICO = {
  1: {
    acessorios_equipamentos: 4,
    danos_acidentais: 2,
    ext_ambito_territorial: 10,
    ext_demais_usuarios: 15,
    ext_utilizacao_competicoes: 25,
    resp_civil_corporais: 1.5000000000000047,
    resp_civil_materiais: 0.9155999999999994,
    subtracao: 2,
    transportes_meios_adequados: 0.3,
  },
  2: {
    acessorios_equipamentos: 5,
    danos_acidentais: 3,
    ext_ambito_territorial: 10,
    ext_demais_usuarios: 15,
    ext_utilizacao_competicoes: 25,
    resp_civil_corporais: 0.625000000000002,
    resp_civil_materiais: 0.3814999999999998,
    subtracao: 2,
    transportes_meios_adequados: 0.3,
  },
  3: {
    acessorios_equipamentos: 5.7749999999999995,
    danos_acidentais: 3.8499999999999996,
    ext_ambito_territorial: 10,
    ext_demais_usuarios: 15,
    ext_utilizacao_competicoes: 25,
    resp_civil_corporais: 0.25000000000000083,
    resp_civil_materiais: 0.15259999999999993,
    subtracao: 1.9249999999999998,
    transportes_meios_adequados: 0.3,
  },
  4: {
    acessorios_equipamentos: 4.4,
    danos_acidentais: 2.6,
    ext_ambito_territorial: 10,
    ext_demais_usuarios: 15,
    ext_utilizacao_competicoes: 25,
    resp_civil_corporais: 1.250000000000004,
    resp_civil_materiais: 0.7629999999999996,
    subtracao: 1.8,
    transportes_meios_adequados: 0.3,
  },
  5: {
    acessorios_equipamentos: 4.65,
    danos_acidentais: 3.1,
    ext_ambito_territorial: 10,
    ext_demais_usuarios: 15,
    ext_utilizacao_competicoes: 25,
    resp_civil_corporais: 1.6250000000000053,
    resp_civil_materiais: 0.9918999999999994,
    subtracao: 1.55,
    transportes_meios_adequados: 0.3,
  },
};

const PERCENTUAL_LMI = {
  70: 1.25,
  80: 1.15,
  90: 1.05,
  100: 1,
  110: 0.95,
  120: 0.9,
};

const TAXAS_EMOTO = {
  70: {
    danos_acidentais_eletricos_subtracao: 8.75,
    danos_acidentais_eletricos: 5.69,
    subtracao: 3.94,
    resp_civil_facultativa_corporais: 1.93,
    resp_civil_facultativa_materiais: 1.18,
    ext_demais_usuarios_ciclomotor: 1.31,
    acessorios_ciclomotor: 8.75,
    acidentes_pessoais_ciclomotor: 0.63,
  },
  80: {
    danos_acidentais_eletricos_subtracao: 8.05,
    danos_acidentais_eletricos: 5.23,
    subtracao: 3.62,
    resp_civil_facultativa_corporais: 1.77,
    resp_civil_facultativa_materiais: 1.08,
    ext_demais_usuarios_ciclomotor: 1.21,
    acessorios_ciclomotor: 8.05,
    acidentes_pessoais_ciclomotor: 0.58,
  },
  90: {
    danos_acidentais_eletricos_subtracao: 7.35,
    danos_acidentais_eletricos: 4.78,
    subtracao: 3.31,
    resp_civil_facultativa_corporais: 1.62,
    resp_civil_facultativa_materiais: 0.99,
    ext_demais_usuarios_ciclomotor: 1.1,
    acessorios_ciclomotor: 7.35,
    acidentes_pessoais_ciclomotor: 0.53,
  },
  100: {
    danos_acidentais_eletricos_subtracao: 7,
    danos_acidentais_eletricos: 4.6,
    subtracao: 3.15,
    resp_civil_facultativa_corporais: 1.54,
    resp_civil_facultativa_materiais: 0.94,
    ext_demais_usuarios_ciclomotor: 1.05,
    acessorios_ciclomotor: 7,
    acidentes_pessoais_ciclomotor: 0.5,
  },
  110: {
    danos_acidentais_eletricos_subtracao: 6.7,
    danos_acidentais_eletricos: 4.3,
    subtracao: 3,
    resp_civil_facultativa_corporais: 1.5,
    resp_civil_facultativa_materiais: 0.9,
    ext_demais_usuarios_ciclomotor: 1,
    acessorios_ciclomotor: 6.7,
    acidentes_pessoais_ciclomotor: 0.5,
  },
  120: {
    danos_acidentais_eletricos_subtracao: 6.3,
    danos_acidentais_eletricos: 4.1,
    subtracao: 2.84,
    resp_civil_facultativa_corporais: 1.39,
    resp_civil_facultativa_materiais: 0.85,
    ext_demais_usuarios_ciclomotor: 0.95,
    acessorios_ciclomotor: 6.3,
    acidentes_pessoais_ciclomotor: 0.45,
  },
};

const EXCLUIR = ['multiplicador', 'bruto', 'comissao', 'liquido'];
const filter_keys = ([key]) => !EXCLUIR.includes(key);

export const aplicar_taxas = (valor_mercado, taxas, porcentagens, coberturas) => {
  const valor_mercado_porcento = valor_mercado / 100;
  const danos_subtracao = taxas.danos_acidentais + taxas.subtracao;
  const apoio = {};
  const bike = {};

  if (coberturas[0]) coberturas[0].label = 'danos_acidentais';

  let simulador = {};

  if (coberturas.length > 0) {
    Object.entries(taxas)
      .filter(([key]) => {
        return coberturas.find((cob) => cob.label === key) || key === 'subtracao';
      })
      .forEach(([key, value]) => {
        apoio[key] = valor_mercado_porcento * (porcentagens[key] ? porcentagens[key] / 100 : 1) * value;
      });
  } else {
    Object.entries(taxas).forEach(([key, value]) => {
      apoio[key] = valor_mercado_porcento * (porcentagens[key] ? porcentagens[key] / 100 : 1) * value;
    });
  }

  if (coberturas.length > 0) {
    MULTIPLICADOS_DANOS_SUBTRACAO.filter((key) => {
      return coberturas.find((cob) => cob.label === key) || key === 'subtracao';
    }).forEach((key) => {
      apoio[key] = (apoio[key] / 100) * danos_subtracao;
    });
  } else {
    MULTIPLICADOS_DANOS_SUBTRACAO.forEach((key) => {
      apoio[key] = (apoio[key] / 100) * danos_subtracao;
    });
  }

  apoio.soma = Object.values(apoio).reduce((prev, curr) => prev + curr, 0);

  apoio.liquido = apoio.soma / (1 - COMISSAO);
  apoio.comissao = apoio.liquido * COMISSAO;
  apoio.bruto = apoio.liquido * PERCENTUAL_BRUTO;

  if (apoio.liquido < 350) {
    simulador.multiplicador = 350 / apoio.liquido;

    Object.entries(apoio).forEach(([key, value]) => {
      simulador[key] = value * simulador.multiplicador;
    });
  } else {
    simulador = {multiplicador: 1, ...apoio};
  }

  bike.multiplicador = simulador.bruto / simulador.soma;

  Object.entries(simulador)
    .filter(filter_keys)
    .forEach(([key, value]) => {
      bike[key] = value * bike.multiplicador;
    });

  bike.danos_acidentais_subtracao = bike.danos_acidentais + bike.subtracao;
  bike.danos_acidentais = bike.danos_acidentais + bike.subtracao;

  return bike;
};

export const aplicar_taxas_bici_basico = (valor_mercado, modalidade, porcentagens, coberturas, lmi_contratado) => {
  let taxas = TAXAS_BICI_SURA_BASICO[modalidade];
  const valor_mercado_porcento = (valor_mercado * (lmi_contratado / 100)) / 100;
  const danos_subtracao = taxas.danos_acidentais + taxas.subtracao;
  const apoio = {};
  const bike = {};

  if (coberturas[0]) coberturas[0].label = 'danos_acidentais';

  let simulador = {};

  Object.entries(taxas)
    .filter(([key]) => {
      return coberturas.find((cob) => cob.label === key) || key === 'subtracao';
    })
    .forEach(([key, value]) => {
      apoio[key] = valor_mercado_porcento * (porcentagens[key] ? porcentagens[key] / 100 : 1) * value; //* PERCENTUAL_LMI[lmi_contratado];
    });

  MULTIPLICADOS_DANOS_SUBTRACAO.filter((key) => {
    return coberturas.find((cob) => cob.label === key) || key === 'subtracao';
  }).forEach((key) => {
    apoio[key] = (apoio[key] / 100) * danos_subtracao;
  });

  apoio.soma = Object.values(apoio).reduce((prev, curr) => prev + curr, 0);

  apoio.liquido = apoio.soma / (1 - COMISSAO);
  apoio.liquido = apoio.liquido * PERCENTUAL_LMI[lmi_contratado];

  apoio.comissao = apoio.liquido * COMISSAO;
  apoio.bruto = apoio.liquido * PERCENTUAL_BRUTO;

  if (apoio.liquido < 200) {
    simulador.multiplicador = 200 / apoio.liquido;

    Object.entries(apoio).forEach(([key, value]) => {
      simulador[key] = value * simulador.multiplicador;
    });
  } else {
    simulador = {multiplicador: 1, ...apoio};
  }

  bike.multiplicador = simulador.bruto / simulador.soma;

  Object.entries(simulador)
    .filter(filter_keys)
    .forEach(([key, value]) => {
      bike[key] = value * bike.multiplicador;
    });

  bike.danos_acidentais_subtracao = bike.danos_acidentais + bike.subtracao;
  bike.danos_acidentais = bike.danos_acidentais + bike.subtracao;

  return bike;
};

export const aplicar_taxas_modais = (modal, valor_mercado, porcentagens, coberturas) => {
  const taxas = TAXAS_MODAIS[modal];
  let apoio = {};
  let simulador = {};

  Object.entries(taxas)
    .filter(([key]) => {
      return coberturas.find((cob) => cob.label === key) || key === 'subtracao';
    })
    .forEach(([key, value]) => {
      apoio[key] = valor_mercado * (porcentagens[key] ? porcentagens[key] / 100 : 1) * value;
    });

  MULTIPLICADOS_DANOS_SUBTRACAO.filter((key) => {
    return coberturas.find((cob) => cob.label === key) || key === 'subtracao';
  }).forEach((key) => {
    apoio[key] = apoio[key] * taxas.danos_acidentais_subtracao;
  });

  apoio.soma = Object.values(apoio).reduce((prev, curr) => prev + curr, 0);

  apoio.liquido = apoio.soma * (1 + COMISSAO);
  apoio.comissao = apoio.liquido * COMISSAO;
  apoio.bruto = apoio.liquido * PERCENTUAL_BRUTO;

  if (apoio.soma < MINIMO_MODAIS[modal].minimo) {
    simulador.multiplicador = MINIMO_MODAIS[modal].minimo / apoio.soma;
    console.log(simulador);

    Object.entries(apoio).forEach(([key, value]) => {
      simulador[key] = value * simulador.multiplicador;
    });
  } else {
    simulador = {multiplicador: 1, ...apoio};
  }

  return simulador;
};

export const aplicar_taxas_eMoto = (valor_mercado, porcentagens, coberturas, lmi_contratado) => {
  let taxas = TAXAS_EMOTO[lmi_contratado];
  valor_mercado = valor_mercado * (lmi_contratado / 100);
  const apoio = {};
  let simulador = {};

  Object.entries(taxas).forEach(([key, value]) => {
    apoio[key] = valor_mercado * (porcentagens[key] ? porcentagens[key] / 100 : 1) * (value / 100);
  });

  apoio['assistencia_ciclomotor'] = 231.6;

  apoio.soma = Object.values(apoio).reduce((prev, curr) => prev + curr, 0);

  apoio.liquido = apoio.soma * (1 + COMISSAO);
  apoio.comissao = apoio.liquido * COMISSAO;
  apoio.bruto = apoio.liquido * PERCENTUAL_BRUTO;

  return apoio;
};
